import { Role } from 'auth';
import { withPrivateAccess } from '@/modules/auth/hocs/withPrivateAccess.tsx';
import { IssuedCapitalOverTimeChart } from '@/modules/issuer-dashboard/components/securities-dashboard/IssuedCapitalOverTimeChart.tsx';
import { IssuedCapitalProgressChart } from '@/modules/issuer-dashboard/components/securities-dashboard/IssuedCapitalProgressChart.tsx';
import { IssuerSecuritiesBalanceStatistics } from '@/modules/issuer-dashboard/components/securities-dashboard/IssuerSecuritiesBalanceStatistics.tsx';
import { LastCertificate } from '@/modules/issuer-dashboard/components/securities-dashboard/LastCertificate.tsx';
import { NavOverTimeChart } from '@/modules/issuer-dashboard/components/securities-dashboard/NavOverTimeChart.tsx';
import { SecurityClasses } from '@/modules/issuer-dashboard/components/securities-dashboard/SecurityClasses.tsx';
import { PageLayout } from 'ui';
import { useDeferredSectionCount } from 'ui/hooks';

const IssuerSecuritiesDashboard = () => {
  const visibleSectionCount = useDeferredSectionCount(6);

  return (
    <PageLayout title="Securities">
      <div className="flex flex-col gap-6 pb-4 w-full">
        {visibleSectionCount >= 1 && <IssuerSecuritiesBalanceStatistics />}

        <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
          {visibleSectionCount >= 2 && <IssuedCapitalOverTimeChart fullHeight={false} />}
          {visibleSectionCount >= 3 && <IssuedCapitalProgressChart />}
        </div>

        <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
          {visibleSectionCount >= 4 && <LastCertificate />}
          {visibleSectionCount >= 5 && <NavOverTimeChart />}
        </div>

        {visibleSectionCount >= 6 && <SecurityClasses />}
      </div>
    </PageLayout>
  );
};

export default withPrivateAccess(IssuerSecuritiesDashboard, [Role.SR_ISSUER, Role.SR_ISSUER_ADMIN]);
